import { useContext } from 'react';
import DashboardAnalyticsRangeSelector from '../components/DashboardAnalyticsRangeSelector';
import AnalyticsFilterBuilder from '../components/Overview/AnalyticsFilterBuilder';
import ChartsGrid from '../components/Overview/ChartsGrid';
import { DashboardContext } from '../contexts/DashboardContext';
import { useOverviewConfig } from '../contexts/OverviewConfigContext';

export default function OverviewPage() {
  const { config } = useOverviewConfig();
  const { analyticsFilters, setAnalyticsFilters, resetAnalyticsFilters } =
    useContext(DashboardContext);

  return (
    <div className="space-y-3 px-3 py-3 lg:space-y-6 lg:px-10 lg:py-6">
      {/* Header */}
      <div className="flex flex-col justify-between gap-4 lg:flex-row lg:items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Overview</h1>
          <p className="mt-1 text-sm text-gray-600">
            Workspace-level analytics and performance metrics
          </p>
        </div>
        <div className="flex items-center gap-2">
          <AnalyticsFilterBuilder
            mode="account"
            filters={analyticsFilters}
            onFiltersChange={setAnalyticsFilters}
            onFiltersReset={resetAnalyticsFilters}
          />
          <DashboardAnalyticsRangeSelector />
        </div>
      </div>

      {/* Charts Grid */}
      <ChartsGrid config={config} analyticsFilters={analyticsFilters} />
    </div>
  );
}
